import { validateArguments } from '../../SignatureValidation';
import { ExprValue } from '../ExprValue';
export var ZnFn;
(function (ZnFn) {
    ZnFn.Name = `ZN`;
    ZnFn.Stage = "SCALAR";
    ZnFn.Signature = `ZN(<expression>)`;
    function make(callName, args, type, role) {
        return {
            name: ZnFn.Name,
            stage: ZnFn.Stage,
            data: { type, role },
            value(value) {
                switch (typeof value) {
                    case 'number':
                    case 'string':
                        return +value;
                }
                if (ExprValue.isNumberValue(value)) {
                    return value;
                }
                if (value == null) {
                    return 0;
                }
                throw new Error(`Invalid input for ZN ${value}`);
            },
        };
    }
    ZnFn.make = make;
    function validate(callNode, callName, args) {
        return validateArguments({
            meta: { name: ZnFn.Name, signature: ZnFn.Signature, location: callNode.location },
            arguments: [
                {
                    type: "NUMERIC",
                },
            ],
        }, args);
    }
    ZnFn.validate = validate;
})(ZnFn || (ZnFn = {}));
